<template>
    <div>
        <!--/* Spinner */-->
        <page-loading-spinner class="over-page-loading-spinner" :is-refresh-loading="isRefreshLoading" />

        <banner v-if="mobileOffersDto.banner" :title="mobileOffersDto.banner" custom-class="bg-warning" />
        <section id="offer-tiles" class="container-fluid pt-1">
            <div class="d-flex flex-row justify-content-between align-items-center my-lg-1">
                <div>
                    <h1 class="mb-0 pb-0" v-html="mobileOffersDto.title" />
                    <div v-if="mobileOffersDto.subTitle">
                        <p class="h4 mb-0" v-html="mobileOffersDto.subTitle" />
                    </div>
                </div>
                <div v-if="mobileOffersDto.digitalCartTooltipDto">
                    <div class="row justify-content-end">
                        <div class="col-auto">
                            <digital-cart-tooltip
                                :title="mobileOffersDto.digitalCartTooltipDto.title"
                                :content="mobileOffersDto.digitalCartTooltipDto.content"
                                :cta-label="mobileOffersDto.digitalCartTooltipDto.ctaLabel"
                                :cta-url="mobileOffersDto.digitalCartTooltipDto.cartPageUrl"
                                :empty-cart="mobileOffersDto.digitalCartTooltipDto.emptyCart"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <ob1-separateur class="my-1" />
                    <div class="mb-1 mt-lg-2">
                        <switch-live-box-customer
                            v-if="mobileOffersDto.openCustomerDto || switchOpen || mobileOffersDto.discountAdvantagesDto"
                            :switch-open="switchOpen"
                            :open-customer-dto="mobileOffersDto.openCustomerDto"
                            :discount-advantages-dto="mobileOffersDto.discountAdvantagesDto"
                            @switch="switchLiveBoxCustomerOffers($event)"
                        />
                    </div>
                </div>
            </div>
            <internet-discount-popin-shared
                v-if="showRemiseInternetPopin && mobileOffersDto.remiseInternetPopinComponent.remiseInternetPopinComponent"
                :id="'remise-offers-open-modal'"
                :dto="mobileOffersDto.remiseInternetPopinComponent.remiseInternetPopinComponent"
                :offers-list="getAllOffersFromTabs()"
                mode="offers"
            />

            <!--/* Page Menu */-->
            <div v-if="showTabs" class="row d-flex justify-content-center mb-2">
                <div :class="offerTabsClasses">
                    <offers-tabs
                        v-if="mobileOffersDto.tabs && mobileOffersDto.tabs.tabsList"
                        :tabs="mobileOffersDto.tabs.tabsList"
                        @toggle-tab="toggleTab"
                    />
                </div>
            </div>

            <!--/* Offres */-->
            <ul class="row list-unstyled">
                <span class="visually-hidden" aria-live="polite">{{ listAccessibilityLabel }}</span>
                <li
                    v-for="(offer, index) in displayedMobileOffersTiles"
                    :key="'offer-' + (offer.idSeo || index)"
                    :data-test-id="'offer-' + index"
                    class="col-12 col-md-6 col-lg-4 mb-1 tile-wrapper"
                >
                    <push-animation-card
                        v-if="offer.type == 'push'"
                        :offer="offer"
                    />
                    <mobile-offer-card
                        v-else
                        data-segment="segment-data"
                        :offer="offer"
                        section-id="segment-data"
                        :advantage-offer-mobile-message="advantageOfferMobileMessage(offer.idSeo)"
                        :is-sub="offer.sub"
                        :is-fmr="switchOpen ? switchOpen.switchDto.checked : withOpenPrices"
                        :is-black="offer.promoted"
                        :show-remise-internet-popin="showRemiseInternetPopin"
                        @selected-offer-details="selectedOfferDetails"
                        @add-offer-in-cart="onAddOfferInCart"
                        @add-offer-in-cart-success="onAddOfferInCartSuccess"
                        @add-offer-in-cart-error="onAddOfferInCartError"
                    />
                </li>
            </ul>
            <div class="row">
                <div class="col-12 text-center mt-1">
                    <ob1-boutons
                        v-if="showMoreOffersButton"
                        class="px-3"
                        :is-button="true"
                        :is-secondary="true"
                        data-test-id="btn-show-more-offers"
                        :label="moreOffersButton + ' (' + nonPushOffersCount + ')'"
                        data-oevent-category="liste_forfait"
                        :data-oevent-action="getLabelToTmsFormat(moreOffersButton)"
                        data-oevent-label="voir_tout"
                        @ob1-boutons-click.prevent="sliceMoreOffersSegments(true)"
                    />
                    <ob1-boutons
                        v-if="showLessOffersButton"
                        class="px-3"
                        :is-button="true"
                        :is-secondary="true"
                        data-test-id="btn-show-less-offers"
                        :label="lessOffersButton"
                        data-oevent-category="liste_forfait"
                        :data-oevent-action="getLabelToTmsFormat(lessOffersButton)"
                        data-oevent-label="voir_moins"
                        @ob1-boutons-click.prevent="sliceLessOffersSegments(true)"
                    />
                </div>
            </div>
            <offers-detail-popin
                v-if="showMobileOffersDetail"
                id="offer-details-popin"
                ref="offerDetailsPopin"
                :new-sub-seo-ids="mobileOffersDto.newSubSeoIds"
                :new-sub-message="mobileOffersDto.newSubMessage"
                :offers="allSelectedMobileOffersTiles"
                :logo5g-src="mobileOffersDto.image5gCds"
                :logo5g-plus-src="mobileOffersDto.image5gPlusCds"
                :show-remise-internet-popin="showRemiseInternetPopin"
                @change-offer-blocked="changeOfferBlocked"
                @add-offer-in-cart="onAddOfferInCart"
                @add-offer-in-cart-success="onAddOfferInCartSuccess"
                @add-offer-in-cart-error="onAddOfferInCartError"
            />
            <template v-for="offer in allSelectedMobileOffersTiles">
                <price-details-popin
                    v-if="offer.priceDetailsPopin"
                    :id="offer.idSeo"
                    :key="'price-details-' + offer.idSeo"
                    :offer-type="offer.offerType || ''"
                    :offer-name="offer.secondaryShortLabel"
                    :offer-price="offer.price"
                    :price-details="offer.priceDetailsPopin"
                />
            </template>
        </section>

        <!--/* Sélection forfaits */-->
        <offers-animation-section :offers-animation="selectionAnimation" />

        <!--/* Avantages */-->
        <section
            v-if="brandAnimation && brandAnimation.title"
            class="content-visibility-auto bg-gray2"
        >
            <brand-animation-section
                class="pt-2 container-fluid"
                :brand-animation="brandAnimation"
            />
        </section>

        <!--/* Animation 5G, FAQ, ... */-->
        <section class="container-fluid pt-2 content-visibility-auto">
            <info-5g-tile
                v-if="showInfoAlert5G"
                :is-sosh="false"
                :is-wide="false"
                :title="mobileOffersDto.infoAlert5G.title"
                :image="mobileOffersDto.image5gCds"
                :list="mobileOffersDto.infoAlert5G.list"
                :link="mobileOffersDto.infoAlert5G.link"
                :class="'px-1'"
            />
            <faq :title="mobileOffersDto.faq && mobileOffersDto.faq.title" :question-list="mobileOffersDto.faq && mobileOffersDto.faq.questionList" />
        </section>

        <ob1-snack-bar
            id="cartPageSnackbar"
            ref="cartPageSnackbar"
            class="over-page-loading-spinner"
            :icon="snackbarIcon"
            :label="snackbarMessage"
        />
    </div>
</template>

<script>
import Faq from "../../../common/fragments/Faq.vue";
import SwitchLiveBoxCustomer from "../fragments/SwitchLiveBoxCustomer.vue";
import MobileOfferCard from "../fragments/MobileOfferCard.vue";
import OffersDetailPopin from "../fragments/OffersDetailPopin.vue";
import PriceDetailsPopin from "../fragments/PriceDetailsPopin.vue";
import Info5gTile from "../../../common/vitrine/Info5gTile.vue";
import BrandAnimationSection from "../../../common/fragments/BrandAnimationSection.vue";
import DigitalCartTooltip from "../../../../common/components/vue/tooltip/DigitalCartTooltip.vue";
import PageLoadingSpinner from "../../../../common/components/custom/PageLoadingSpinner.vue";
import OffersAnimationSection from "../../../../common/components/vue/animation/OffersAnimationSection.vue";
import {alignDivsHeightsByLine} from "../../../../orange/broadband/utils/AlignDivHeightsUtil";
import {createAnnouncement} from "../../../../common/utils/HtmlUtils";
import Banner from "../../../common/components/Banner.vue";
import OffersTabs from "../../../../orange/broadband/internet/showcase/components/OffersTabs.vue";
import PushAnimationCard from "../fragments/PushAnimationCard.vue";
import InternetDiscountPopinShared from "../../../../common/components/sponsor/InternetDiscountPopinShared.vue";
import {MobileOffersCdsService} from "../services/MobileOffersCdsService";

const mobileOffersDto = JSON.parse(document.getElementById('mobile-offers-cds').dataset.mobileOffersDto);
export default {
    name: "OffersCds",
    components: {
        PushAnimationCard,
        PriceDetailsPopin,
        Banner,
        OffersAnimationSection,
        PageLoadingSpinner,
        DigitalCartTooltip,
        BrandAnimationSection,
        Info5gTile,
        OffersDetailPopin,
        MobileOfferCard,
        SwitchLiveBoxCustomer,
        Faq,
        OffersTabs,
        InternetDiscountPopinShared
    },
    data() {
        return {
            mobileOffersDto: mobileOffersDto,
            selectedMobileOffersTiles: null,
            allSelectedMobileOffersTiles: null,
            displayedMobileOffersTiles: [],
            brandAnimation: mobileOffersDto.brandAnimation,
            selectionAnimation: mobileOffersDto.selectionTileDto,
            withOpenPrices: mobileOffersDto.withOpenPrices,
            switchOpen: mobileOffersDto.switch,
            fmr: false,
            selectedTabId: null,
            offersOffset: 0,
            showTabs: mobileOffersDto.tabs != null,
            blocked: true,
            blockedByGroupKey: {},
            moreOffersButton: mobileOffersDto.moreOffersButtonLabel,
            lessOffersButton: mobileOffersDto.lessOffersButtonLabel,
            selectedOfferIdSeo: "",
            snackbarMessage: "",
            snackbarIcon: "icon-error-severe",
            isRefreshLoading: false,
            hashChangeHandler: null,
            resizeAlignHandler: null,
        }
    },
    computed: {
        showRemiseInternetPopin() {
            return this.mobileOffersDto.remiseInternetPopinComponent !== undefined
                && this.mobileOffersDto.remiseInternetPopinComponent !== null
                && this.switchOpen
                && this.switchOpen.switchDto
                && this.switchOpen.switchDto.checked;
        },
        nonPushOffersCount() {
            return this.selectedMobileOffersTiles ? this.selectedMobileOffersTiles.filter(o => o.type !== 'push').length : 0;
        },
        offersLengthByTabs() {
            if (this.mobileOffersDto.tabs != null) {
                return this.mobileOffersDto.tabs.tabsList.map(el => el.offers.length)
            }
            else {
                return [];
            }
        },
        hasEmptyTabs() {
            return this.offersLengthByTabs.find(el => el === 0) != null;
        },
        showInfoAlert5G() {
            return this.displayedMobileOffersTiles.filter(offer => offer.technologyLogo !== undefined).length > 0;
        },
        showMobileOffersDetail() {
            return this.selectedMobileOffersTiles && this.selectedMobileOffersTiles.length > 0
        },
        showMoreOrLessOffersButton() {
            return this.selectedMobileOffersTiles !== null
                && this.selectedMobileOffersTiles.length > 3
                && this.displayedMobileOffersTiles !== null
        },
        showMoreOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedMobileOffersTiles.length < this.selectedMobileOffersTiles.length;
        },
        showLessOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedMobileOffersTiles.length >= this.selectedMobileOffersTiles.length;
        },
        openPacks() {
            const zigZagItemsUpdate = {...this.mobileOffersDto.openPacks}.zigZagItems.map(zigZagItem => {
                let imageUpdate = {...zigZagItem.image, xxlSrcSet: zigZagItem.image.xlSrcSet}
                return {...zigZagItem, image: imageUpdate}
            })
            return {...this.mobileOffersDto.openPacks, zigZagItems: zigZagItemsUpdate}
        },
        listAccessibilityLabel() {
            if (!this.selectedTabId) return '';
            const nombreForfaits = this.nonPushOffersCount;
            return `sur ${nombreForfaits} forfait${nombreForfaits > 1 ? 's' : ''} disponible${nombreForfaits > 1 ? 's' : ''}`;
        },
        cartOfferTab() {
            if (!this.mobileOffersDto.tabs) return null;
            return this.mobileOffersDto.tabs.tabsList.find(tab =>
                tab.offers.some(offer => offer.alreadyInCartOfferLabel)
            ) || null;
        },
        offerTabsClasses() {
            const numberOfTabs = this.mobileOffersDto.tabs?.tabsList?.length || 0;
            switch (numberOfTabs) {
                case 2: return "col-12 col-md-6";
                case 3: return "col-12 col-xxl-9";
                default : return "col-12";
            }
        }
    },
    created() {
        if (this.cartOfferTab && this.readHash() === "") {
            window.history.replaceState(null, "", "#" + this.cartOfferTab.id);
        }
    },
    mounted() {
        this.removeSkeleton();
        this.initUrl();
        this.initBlockedState();
        this.refreshDerivedState();
        this.hashChangeHandler = () => this.selectMobileOffersTilesList(this.fmr);
        this.resizeAlignHandler = this.alignElementsOnNextTick;
        window.addEventListener("hashchange", this.hashChangeHandler);
        window.addEventListener("resize", this.resizeAlignHandler);
        if (this.mobileOffersDto.showAllOffers) {
            this.sliceMoreOffersSegments();
        }
        this.alignElementsOnNextTick();
    },
    beforeDestroy() {
        if (this.hashChangeHandler) {
            window.removeEventListener("hashchange", this.hashChangeHandler);
        }
        if (this.resizeAlignHandler) {
            window.removeEventListener("resize", this.resizeAlignHandler);
        }
    },
    updated() {
        this.$nextTick(function () {
            this.alignElements();
        })
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        initBlockedState() {
            const allOffers = this.mobileOffersDto.tabs
                ? this.mobileOffersDto.tabs.tabsList.flatMap(tab => tab.offers)
                : [];
            const offerInCart = allOffers.find(offer => offer.alreadyInCartOfferLabel && offer.blocked !== undefined);
            if (offerInCart) {
                this.blocked = offerInCart.blocked;
            }

            this.initializeBlockedByOfferMap(allOffers);
        },
        initializeBlockedByOfferMap(allOffers) {
            const offersByGroupKey = {};

            allOffers
                .filter(offer => offer.blocked !== undefined)
                .forEach(offer => {
                    const groupKey = this.getBlockedGroupKey(
                        offer.idSeo,
                        offer.equivalentBlockedOrUnblockedVersionIdSeo
                    );

                    if (!offersByGroupKey[groupKey]) {
                        offersByGroupKey[groupKey] = [];
                    }

                    offersByGroupKey[groupKey].push(offer);
                });

            Object.keys(offersByGroupKey).forEach(groupKey => {
                const offersForGroup = offersByGroupKey[groupKey];
                const offerAlreadyInCart = offersForGroup.find(offer => offer.alreadyInCartOfferLabel);
                const selectedOffer = offerAlreadyInCart || offersForGroup[0];

                this.$set(this.blockedByGroupKey, groupKey, selectedOffer.blocked);
            });
        },
        getBlockedGroupKey(offerIdSeo, equivalentOfferIdSeo) {
            if (!equivalentOfferIdSeo) {
                return offerIdSeo;
            }

            return [offerIdSeo, equivalentOfferIdSeo].sort().join('|');
        },
        advantageOfferMobileMessage(offerIdSeo) {
            if (this.mobileOffersDto.advantageOfferMobileSeoIds.includes(offerIdSeo)) {
                return this.mobileOffersDto.advantageOfferMobileMessage;
            }
            return null;
        },
        removeSkeleton() {
            document.getElementById("skeleton-mobile-offers").remove()
        },
        initUrl() {
            if (this.switchOpen) {
                if (!window.location.href.includes('internet')) {
                    // ajoute le paramètre internet en fonction de l'éligibilité fmr du client
                    const withOpenPricesString = this.withOpenPrices ? "true" : "false";
                    const baseUrl = window.location.pathname + window.location.search;
                    const urlWithParam = addParam(baseUrl, "internet=" + withOpenPricesString);
                    const newUrl = urlWithParam + window.location.hash;
                    window.history.replaceState({}, null, newUrl);
                }
            }
        },
        switchLiveBoxCustomerOffers(event) {
            this.fmr = event.checked;
            this.updateOpenSwitchList(event.checked);
            this.updateUrl(event.checked);
            this.sendTmsOfferTypeView(event.checked);
            // Si tabs actifs, relancer le filtrage sur l'onglet sélectionné
            if ((this.mobileOffersDto.tabs?.tabsList?.length || 0) > 0) {
                let tabId = this.selectedTabId;
                // Si aucun onglet sélectionné, prendre le premier
                if (!tabId) {
                    tabId = this.mobileOffersDto.tabs.tabsList[0].id;
                    this.selectedTabId = tabId;
                }
                const tabEl = this.mobileOffersDto.tabs.tabsList.find(el => el.id === tabId);
                if (tabEl) {
                    this.filterOffers(tabEl.offers, this.fmr);
                    this.refreshDisplayedOffers();
                }
            }
            // Sinon, fallback comportement existant (toutes les offres)
            else {
                this.filterOffers(this.mobileOffersTiles, this.fmr);
                this.refreshDisplayedOffers();
            }
            this.alignElementsOnNextTick();
        },
        updateOpenSwitchList(checked) {
            if (this.switchOpen) {
                this.switchOpen.switchDto.checked = checked
            }
        },
        refreshDisplayedOffers() {
            this.offersOffset = Math.min(this.offersOffset, this.selectedMobileOffersTiles.length);
            this.displayedMobileOffersTiles = this.selectedMobileOffersTiles.slice(0, this.offersOffset);
        },
        sliceMoreOffersSegments(shouldMoveFocus = false) {
            const beginOffset = this.offersOffset;
            const previousCount = this.displayedMobileOffersTiles.length;

            if (this.offersOffset < this.selectedMobileOffersTiles.length) {
                if (this.offersOffset === 0 && this.selectedMobileOffersTiles.length > 3) {
                    this.offersOffset = 3;
                } else {
                    this.offersOffset = this.selectedMobileOffersTiles.length;
                }
            }

            this.displayedMobileOffersTiles = this.selectedMobileOffersTiles.slice(0, this.offersOffset);

            const newlyAddedCount = beginOffset === 0 ? 0 : (this.displayedMobileOffersTiles.length - previousCount);

            this.announceOfferListUpdate(previousCount, newlyAddedCount, shouldMoveFocus);

            return this.displayedMobileOffersTiles;
        },
        sliceLessOffersSegments(shouldMoveFocus = false) {
            const beginOffset = this.offersOffset;
            const previousCount = this.displayedMobileOffersTiles.length;

            if (this.offersOffset < 0) {
                return
            }

            this.offersOffset = 3;
            this.displayedMobileOffersTiles = this.selectedMobileOffersTiles.slice(0, this.offersOffset);

            const newlyRemovedCount = beginOffset === 0 ? 0 : (this.displayedMobileOffersTiles.length - previousCount);

            this.announceOfferListUpdate(previousCount, newlyRemovedCount, shouldMoveFocus);

            return this.displayedMobileOffersTiles;
        },
        updateUrl(fmr) {
            const newUrl = new URL(window.location.href);
            this.switchOpen ? newUrl.searchParams.set("internet", fmr) : newUrl.searchParams.delete("internet");
            window.history.replaceState({}, null, newUrl.toString());
        },
        sendTmsOfferTypeView(fmr) {
            if (!window.o_utagview || !window.o_data || !window.o_data.offre_type) {
                return;
            }
            const offerType = fmr ? "forfait_postpaid_fmo_orange" : "forfait_postpaid_fm_orange";
            const offersCount = window.o_data.offre_type.split(";").length;
            Tms.view({offre_type: new Array(offersCount).fill(offerType).join(";")});
        },
        alignElements() {
            const listOfDivToAlign = [
                "title-wrapper", "advantage-message-wrapper", "base-price-wrapper", "final-price-wrapper", "price-wrapper", "claim-wrapper", "message-wrapper", "cart-item-status-wrapper"
            ];
            alignDivsHeightsByLine(listOfDivToAlign);
        },
        alignElementsOnNextTick() {
            this.$nextTick(this.alignElements);
        },
        refreshDerivedState() {
            this.brandAnimation = this.mobileOffersDto.brandAnimation;
            this.selectionAnimation = this.mobileOffersDto.selectionTileDto;
            this.withOpenPrices = this.mobileOffersDto.withOpenPrices;
            this.switchOpen = this.mobileOffersDto.switch;
            this.showTabs = this.mobileOffersDto.tabs != null;
            this.moreOffersButton = this.mobileOffersDto.moreOffersButtonLabel;
            this.lessOffersButton = this.mobileOffersDto.lessOffersButtonLabel;
            this.fmr = this.switchOpen && this.switchOpen.switchDto ? this.switchOpen.switchDto.checked : (this.mobileOffersDto.withOpenPrices || false);
            this.selectMobileOffersTilesList(this.fmr);
        },
        selectedOfferDetails(offer) {
            this.$refs.offerDetailsPopin.radioButtonOfferSelected = offer;
        },
        changeOfferBlocked(blocked) {
            const blockedOffer = (typeof blocked === 'object' && blocked !== null) ? blocked : {blocked: blocked};
            const wereAllOffersExpanded = this.areAllOffersExpanded();
            if (blockedOffer.offerIdSeo) {
                const groupKey = this.getBlockedGroupKey(blockedOffer.offerIdSeo, blockedOffer.equivalentOfferIdSeo);
                this.$set(this.blockedByGroupKey, groupKey, blockedOffer.blocked);
            }

            this.blocked = blockedOffer.blocked
            this.$nextTick(() => {
                this.selectMobileOffersTilesList(this.fmr);

                if (wereAllOffersExpanded) {
                    this.offersOffset = this.selectedMobileOffersTiles.length;
                    this.refreshDisplayedOffers();
                }
            });
        },
        areAllOffersExpanded() {
            return this.selectedMobileOffersTiles !== null
                && this.selectedMobileOffersTiles.length > 0
                && this.displayedMobileOffersTiles.length >= this.selectedMobileOffersTiles.length;
        },
        getLabelToTmsFormat(label) {
            return stripAccents(label).split(' ').join('_');
        },
        onAddOfferInCart(idSeo) {
          this.isRefreshLoading = true;

          const addMobileOfferSuccessHandler = (response) => {
              // Met à jour le mobileOffersDto à partir des données renvoyées par addToCart.
            if (response.data && response.data.mobileOffersDto) {
              this.mobileOffersDto = response.data.mobileOffersDto;
              this.refreshPageData();
            }
            this.displayMessageAndRefresh(response.data);
            const redirectUrl = this.mobileOffersDto.digitalCartTooltipDto?.cartPageUrl;
            if (redirectUrl) {
              window.location.href = redirectUrl
            }
          };

          const addMobileOfferFailHandler = (error) => {
            const snackBarAlert = error.response && error.response.data && error.response.data.snackBarAlert
                ? error.response.data.snackBarAlert : {
                  message: "Une erreur est survenue lors de l'ajout de l'offre dans votre panier",
                  icon: "icon-error-severe"
                };
            const event = {snackBarAlert};
            this.displayMessageAndRefresh(event);
          };

          MobileOffersCdsService.addToCartAndUpdateOffers({seoId: idSeo})
            .then(addMobileOfferSuccessHandler)
            .catch(addMobileOfferFailHandler)
            .finally(() => {
              this.isRefreshLoading = false;
            });

          return false;
        },
        onAddOfferInCartSuccess(event) {
          if (event && event.response && event.response.data && event.response.data.mobileOffersDto) {
            this.mobileOffersDto = event.response.data.mobileOffersDto;

            if (event.fromCds) {
              this.simulateHardRefresh();
            } else {
              this.refreshPageData();
            }
          }
          if (event.response.data && event.response.data.snackBarAlert) {
            this.displaySnackBarAlertMessage(event.response.data.snackBarAlert);
          }
        },
        onAddOfferInCartError(event) {
          const error = event.error;
          const snackBarAlert = error.response && error.response.data && error.response.data.snackBarAlert
              ? error.response.data.snackBarAlert : {
                message: "Une erreur est survenue lors de l'ajout de l'offre dans votre panier",
                icon: "icon-error-severe"
              };
          this.displaySnackBarAlertMessage(snackBarAlert);
        },
        simulateHardRefresh() {
            this.selectedMobileOffersTiles = null;
            this.allSelectedMobileOffersTiles = null;
            this.displayedMobileOffersTiles = [];
            this.selectedTabId = null;
            this.offersOffset = 0;
            this.blocked = true;
            this.blockedByGroupKey = {};

            this.initUrl();
            this.refreshPageData();
            if (this.mobileOffersDto.showAllOffers) {
                this.sliceMoreOffersSegments();
            }
            this.alignElementsOnNextTick();
        },
        refreshPageData() {
            this.initBlockedState();
            this.refreshDerivedState();
        },
        displayMessageAndRefresh: function (event) {
          if (event && event.snackBarAlert) {
            this.displaySnackBarAlertMessage(event.snackBarAlert);
          }
        },
        displaySnackBarAlertMessage: function (snackBarAlert) {
          if (snackBarAlert) {
            this.snackbarMessage = snackBarAlert.message;
            this.snackbarIcon = snackBarAlert.icon;
            const snackbar = this.$refs.cartPageSnackbar;
            if (snackbar) {
              snackbar.show();
            }
          }
        },
        selectMobileOffersTilesList(fmr) {
            // Si on a des onglets à afficher et que en fonction de la résolution on a plus de 2 offres ou 4 offres
            if (this.mobileOffersDto.tabs) {
                // si un des onglets est vide, on charge la liste des offres des autres onglets
                if (this.hasEmptyTabs) {
                    this.loadAllTabsOffers(fmr);
                }
                // sinon, on charge les onglets avec leurs offres
                else {
                    const hasOneTabOnlyOneOffer = this.offersLengthByTabs.find(el => el === 1) != null;

                    // Si en fonction de la résolution, on a plus de 1 offre ou 2 offres minimum par onglet, alors on affiche les onglets
                    if ((window.innerWidth < 736 && !this.hasEmptyTabs) ||
                        (window.innerWidth >= 736 && !hasOneTabOnlyOneOffer)
                    ) {
                        this.loadCurrentTabsOffers(fmr);
                    }
                    // Sinon, on masque les onglets et on charge les offres de tous les onglets
                    else {
                        this.loadAllTabsOffers(fmr);
                    }
                }
            }
            // si pas d'onglets à afficher, on charge toutes les offres par defaut
            else {
                this.loadAllOffersByDefault(fmr);
            }
        },
        loadCurrentTabsOffers(fmr) {
            // Pas de hashtag, on charge les offres du premier onglet par défaut
            if (this.readHash() === "") {
                this.loadFirstTab(fmr);
            }
            // On a un hashtag, on le contrôle et on charge les offres de l'onglet correspondant uniquement
            else {
                let hashTagOK = false;
                this.mobileOffersDto.tabs.tabsList.forEach(
                    (el) => {
                        if (el.id === this.readHash()) {
                            this.toggleTab({tab: el.id}, fmr);
                            hashTagOK = true;
                        }
                    }
                )
                // si hashtag inconnu des id des tabs on le reset
                if (!hashTagOK) {
                    this.loadFirstTab(fmr);
                }
            }
            this.showTabs = true
        },
        loadAllTabsOffers(fmr) {
            this.showTabs = false;
            this.offersOffset = 0;
            this.selectedMobileOffersTiles = this.mobileOffersDto.tabs.tabsList.flatMap(el => el.offers);
            this.filterOffers(this.selectedMobileOffersTiles, fmr);
            this.sliceMoreOffersSegments();
        },
        loadAllOffersByDefault(fmr) {
            this.showTabs = false;
            this.offersOffset = 0;
            this.selectedMobileOffersTiles = this.mobileOffersTiles;
            this.filterOffers(this.selectedMobileOffersTiles, fmr);
            this.sliceMoreOffersSegments();
        },
        loadFirstTab(fmr) {
            this.offersOffset = 0;
            this.selectedMobileOffersTiles = this.mobileOffersDto.tabs.tabsList[0].offers;
            this.selectedTabId = this.mobileOffersDto.tabs.tabsList[0].id;
            this.filterOffers(this.selectedMobileOffersTiles, fmr);
            this.sliceMoreOffersSegments();
        },
        filterOffers(offers, fmr) {
            // On filtre les offres FMR ou non et on sauvegarde l'ensemble pour OffersDetailPopin
            // Les offres de type "push" doivent toujours être conservées
            this.allSelectedMobileOffersTiles = offers.filter(offer => {
                const isPushOffer = offer.type === 'push';
                const isFmrMatch = this.switchOpen ? offer.fmr === fmr : true;
                return isPushOffer || isFmrMatch;
            });

            // On filtre les forfaits bloqués/non bloqués pour n'afficher qu'un seul forfait de la combinaison
            this.selectedMobileOffersTiles = this.allSelectedMobileOffersTiles.filter(offer =>
                offer.blocked === undefined || this.isOfferMatchingBlockedSelection(offer)
            );
        },
        isOfferMatchingBlockedSelection(offer) {
            const groupKey = this.getBlockedGroupKey(
                offer.idSeo,
                offer.equivalentBlockedOrUnblockedVersionIdSeo
            );
            const selectedBlocked = this.blockedByGroupKey[groupKey];
            const blockedSelection = selectedBlocked === undefined ? this.blocked : selectedBlocked;
            return offer.blocked === blockedSelection;
        },
        getAllOffersFromTabs() {
            if (this.mobileOffersDto.tabs && this.mobileOffersDto.tabs.tabsList) {
                return this.mobileOffersDto.tabs.tabsList.flatMap(tab => Array.isArray(tab.offers) ? tab.offers : []);
            }
            return [];
        },
        toggleTab(selectedTab) {
            if (!this.mobileOffersDto.showAllOffers) {
                this.offersOffset = 0;
            }

            // Si on a des onglets, on les parcourt pour charger les offres de l'onglet sélectionné
            if (this.mobileOffersDto.tabs != null && !this.hasEmptyTabs) {
                this.mobileOffersDto.tabs.tabsList.forEach(
                    (el) => {
                        if (selectedTab.tab === el.id) {
                            this.filterOffers(el.offers, this.fmr);
                        }
                    }
                );
                this.selectedTabId = selectedTab.tab;
            }
            this.sliceMoreOffersSegments();
        },
        announceOfferListUpdate(previousNumberOfOffers, numberOfUpdate, shouldMoveFocus = false) {
            this.$nextTick(() => {
                // Delai pour s'assurer que la page est à jour
                setTimeout(() => {
                    if (numberOfUpdate > 0) {
                        // Annoncer le nombre de nouvelles offres
                        createAnnouncement(`Affichage de ${numberOfUpdate} nouvelles offres`);

                        if (shouldMoveFocus) {
                            // Supprimer le focus de la première offre
                            const firstOffer = document.querySelector('.tile-wrapper');
                            if (firstOffer && typeof firstOffer.focus === 'function') {
                                firstOffer.removeAttribute('tabindex', '-1');
                            }

                            // Déplacer le focus vers la première nouvelle offre
                            const firstNewOfferIndex = previousNumberOfOffers;
                            const offerElements = document.querySelectorAll('.tile-wrapper');
                            if (offerElements.length > firstNewOfferIndex) {
                                const element = offerElements[firstNewOfferIndex];
                                element.setAttribute('tabindex', '-1');
                                if (element && typeof element.focus === 'function') {
                                    element.focus();
                                }
                            }
                        }
                    } else if (numberOfUpdate < 0) {
                        // Annoncer la réduction du nombre d'offres
                        createAnnouncement(`Affichage réduit à ${this.offersOffset} offres`);

                        if (shouldMoveFocus) {
                            // Déplacer le focus vers la première offre
                            const firstOffer = document.querySelector('.tile-wrapper');
                            if (firstOffer && typeof firstOffer.focus === 'function') {
                                firstOffer.setAttribute('tabindex', '-1');
                                firstOffer.focus({ focusVisible: false });
                            }
                        }
                    }
                }, 100);
            });

            this.$nextTick(function () {
                this.alignElements();
            })
        }
    }
}
</script>

<style lang="scss">
.sticky {
    position: sticky;
    top: 0;
    z-index: 3;
}

.ob1-menu-page .ob1-nav-light > .nav-item:not(:first-child) > .nav-link {
    margin-left: 60px;
}

.over-page-loading-spinner {
  z-index: 10000;
}

:focus, :focus-visible {
    outline: none;
}

</style>
